<!-- Titles -->
<div class="row">
    <div class="col-md-12">
        <h1>
            {{title | translate}}
            <i class="fa fa-trash float-right pl-3 cursor-po-c" matTooltip="{{'gen_delete' | translate}}"
                matTooltipClass="theme-tooltip" (click)="delete()" *ngIf="isEdit==true"></i>
            <i class="fa fa-pen float-right px-3 cursor-po-c" matTooltip="{{'gen_edit' | translate}}"
                matTooltipClass="theme-tooltip" (click)="isEdit = !isEdit"></i>
        </h1>
    </div>
    <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!assets?.length">
        <h2>{{'gen_no_data' | translate}}</h2>
    </div>
</div>
<!-- Data -->
<div class="row">
    <div class="col-4 col-md-2 text-center my-3 cursor-po" [ngClass]="{'col-6 col-md-3': posterType == 'h'}"
        *ngFor="let asset of assets">
        <div class="selection-shadow" (click)="select(asset)" *ngIf="isEdit">
            <i class="far fa-3x" [ngClass]="{'fa-check-square': asset.isSelected, 'fa-square': !asset.isSelected }"></i>
        </div>
        <app-asset-card [asset]="asset" [style]="posterType == 'h' ? 'B' : 'C'"></app-asset-card>
    </div>
</div>